import FileRepository from "@/repositories/monitorExams/FileRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'file',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOrderFiles({commit, state}, orderId) {
            commit('setLoading', true)
            await FileRepository.getOrderFiles(orderId)
                .then(response => {
                    commit('setAll', [...state.list, ...response.data.data])
                }).catch(console.error)
            commit('setLoading', false)
        },
        async listReportFiles({commit, state}, reportId) {
            commit('setLoading', true)
            await FileRepository.getReportFiles(reportId)
                .then(response => {
                    commit('setAll', [...state.list, ...response.data.data])
                }).catch(console.error)
            commit('setLoading', false)
        }
    }
}
